import { BASE_URL } from '../../../../utils/rest-api-request-url';
import _ from 'lodash';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AlertService, QuotationService, BookingSheetModel, CfsModel, CfsService, CnsltnShpnadvModel, RouteEditModel, AirLineService, OceanLineService
  , OceanLine, AirLine, NewComment } from '../../../../services/index';
import { FileUploader } from 'ng2-file-upload';
import { Subscription } from 'rxjs/Subscription';
import { Util } from 'app/utils';
import { ApiService } from 'app/services/api.service';

declare var $:any;
declare var moment:any;

@Component({
  selector: 'booking-sheet',
  templateUrl: 'booking-sheet.html'
})


export class BookingSheetComponent implements OnChanges {
  @Input() bookedQuot;
  @Input() quotRoutes;
  @Input() cnsltnReq;
  @Input() docLst;
  @Input() cnsltnTruckLst;
  @Input() cnsltnBook;
  @Input() cnsltnShpnadv;
  // @Input('cnsltnReq') 
  // set cnsltnReq(cnsltnReq:any){
  //   if(!cnsltnReq) return;
  //   this._cnsltnReq = cnsltnReq;
  //   let lineService:any = this.oceanLineService;
  //   if(this.cnsltnReq.transTp == 1){
  //     lineService = this.airLineService;
  //   }
  //   lineService.lineListEe.subscribe(data => {
  //     this.lineList = data;
  //   });

  //   if(!this.lineList || this.lineList.length < 1){
  //     this.lineList = lineService.lineList;
  //   }
  // }
  // get cnsltnReq(){
  //   return this._cnsltnReq;
  // }
  
  @Output() fileListEe: EventEmitter<any> = new EventEmitter();
  _cnsltnReq:any;
  fileType:string = '';
  fileTypeETC:boolean = false;
  fileList: Array<any> = new Array();
  filledFileCount: Array<any> = new Array();
  fileTypeETCName:string = '';

  uploader: FileUploader = new FileUploader({});
  uploader2: FileUploader = new FileUploader({});

  bookingSheet: BookingSheetModel = new BookingSheetModel();
  shippingAdvice: CnsltnShpnadvModel = new CnsltnShpnadvModel();

  docTimeList: Array<string> = new Array();
  vgmTimeList: Array<string> = new Array();
  carTimeList: Array<string> = new Array();
  timeListAm: Array<string> = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00'];
  timeListPm: Array<string> = ['12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];
  docTimeValue = '00:00';
  docTimeAmPm: string = 'AM';
  vgmTimeValue = '00:00';
  vgmTimeAmPm: string = 'AM';
  carTimeValue = '00:00';
  carTimeAmPm: string = 'AM';

  cfsList: Array<CfsModel>;

  selectedEmptyCfs;
  selectedInCfs;
  selectedDestCfs;

  blTypeSelect:string = '';  

  isBooking: boolean = false;
  isSaving: boolean = false;

  hBlNo;
  mBlNo;

  isLineOpen:boolean = false;
  lineList:Array<any> = new Array<any>();
  filterLineList:Array<any> = new Array<any>();
  focusedLineIndex:number = 0;
  @ViewChild("lineList")
  lineListElRef: ElementRef;
  routeClickIndex:number = 0;

  airLineListEeSub:Subscription;
  oceanLineListEeSub:Subscription;

  showRejectModal: boolean = false;
  rejectisNotEtc: boolean = true;  
  cancelCmt: NewComment;
  rejectQuotNo: string;

  constructor(
    private alertService: AlertService,
    private quotationService: QuotationService,
    private cfsService: CfsService,
    private airLineService : AirLineService,
    private oceanLineService : OceanLineService,
    private apiService : ApiService
  ) {}

  ngOnDestroy(){
    if(this.airLineListEeSub) this.airLineListEeSub.unsubscribe();
    if(this.oceanLineListEeSub) this.oceanLineListEeSub.unsubscribe();
  }
  
  ngOnInit() {
    //this.bookingSheet.emptyCfs = new CfsModel();
    //this.bookingSheet.inCfs = new CfsModel();

    let lineService:any = this.oceanLineService;
    if(this.cnsltnReq.transTp == 1){
      lineService = this.airLineService;
      this.airLineListEeSub = this.airLineService.lineListEe.subscribe(data => {
        this.lineList = data;
      });
      if(!this.airLineService.ingFlag)this.airLineService.getAirLineList();
    }else{
      lineService = this.oceanLineService;
      this.oceanLineListEeSub = this.oceanLineService.lineListEe.subscribe(data => {
        this.lineList = data;
      });
      if(!this.oceanLineService.ingFlag)this.oceanLineService.getOceanLineList();
    }
  


    // if(!this.lineList || this.lineList.length < 1){
    //   this.lineList = lineService.lineList;
    // }

    if(this.cnsltnBook!= null) this.bookingSheet = this.cnsltnBook;
    if(this.cnsltnShpnadv!= null) this.shippingAdvice = this.cnsltnShpnadv;
    
    this.initFileList();

    this.docTimeList = this.timeListAm;
    this.vgmTimeList = this.timeListAm;
    this.carTimeList = this.timeListAm;

    if(this.bookingSheet.docCloseTm != null) {
      this.docTimeAmPm = this.timeCheck(this.bookingSheet.docCloseTm);
      if(this.docTimeAmPm == 'PM') this.docTimeList = this.timeListPm;
      this.docTimeValue = moment(this.bookingSheet.docCloseTm, 'HHmm').format('HH:mm').toString();
    }

    if(this.bookingSheet.vgmCloseTm != null) {
      this.vgmTimeAmPm = this.timeCheck(this.bookingSheet.vgmCloseTm);
      if(this.vgmTimeAmPm == 'PM') this.vgmTimeList = this.timeListPm;
      this.vgmTimeValue = moment(this.bookingSheet.vgmCloseTm, 'HHmm').format('HH:mm').toString();
    }

    if(this.bookingSheet.cargoCloseTm != null) {
      this.carTimeAmPm = this.timeCheck(this.bookingSheet.cargoCloseTm);
      if(this.carTimeAmPm == 'PM') this.carTimeList = this.timeListPm;
      this.carTimeValue = moment(this.bookingSheet.cargoCloseTm, 'HHmm').format('HH:mm').toString();
    }
    
    this.cfsService.getCfsList().subscribe(
      resp => {
        this.cfsList = resp.data;
      }
    );

    if(this.bookingSheet.blType != null) {
      if(this.bookingSheet.blType == 0 || this.bookingSheet.blType == 1 || this.bookingSheet.blType == 2) {
        this.blTypeSelect = 'm-direct';
      } else {
        this.blTypeSelect = 'hbl';
      }
    }

    this.hBlNo = this.cnsltnReq.hblNo;
    this.mBlNo = this.cnsltnReq.mblNo;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initFileList();

    if(changes.quotRoutes != null) this.routeTTimes();
  }

  routeTTimes() {    
    if(this.quotRoutes != null) {
      for(let i = 0; i < this.quotRoutes.length; i++) {
        if(this.bookedQuot.quotRouteList[i].outDt != null && this.bookedQuot.quotRouteList[i+1] != null) {
          if(this.bookedQuot.quotRouteList[i+1].inDt != null) {
            if(this.cnsltnReq.transTp == 0) {
              this.tTimeCheckSea(this.bookedQuot.quotRouteList[i+1].inDt, this.bookedQuot.quotRouteList[i].outDt, i);
            } else {
              this.tTimeCheckAir(this.bookedQuot.quotRouteList[i+1].inDt, this.bookedQuot.quotRouteList[i].outDt, i);
            }
          }
        }
      }
    }
  }

  etdEtaFormat(time, type) {
    let timeFormat;
    if(type == 'sea') {
      timeFormat = moment(time, "YYYYMMDD").format('YYYY/MM/DD');
    } else {
      timeFormat = moment(time, "YYYYMMDDHHmm").format('YYYY/MM/DD h:mm A');
    }
    return timeFormat;
  }

  modeChange(event, i) {
    // this.postRoute(i);  
  }

  etdChange(event, i, type) {
    if(type == 'sea') {
      this.bookedQuot.quotRouteList[i].outDt = moment(event, 'MM/DD/YYY').format('YYYYMMDD');
    } else {
      this.bookedQuot.quotRouteList[i].outDt = moment(event, 'MM/DD/YYYY h:mm a').format('YYYYMMDDHHmm');
    }
    

    if(this.bookedQuot.quotRouteList[i+1].inDt != null) {
      if(type == 'sea') {
        this.tTimeCheckSea(this.bookedQuot.quotRouteList[i+1].inDt, this.bookedQuot.quotRouteList[i].outDt, i);
      } else {
        this.tTimeCheckAir(this.bookedQuot.quotRouteList[i+1].inDt, this.bookedQuot.quotRouteList[i].outDt, i);
      }
    }
    
    // this.postRoute(i);
  }

  
  etaChange(event, i, type) {
    if(type == 'sea') {
      this.bookedQuot.quotRouteList[i+1].inDt = moment(event, 'MM/DD/YYYY').format('YYYYMMDD');
    } else {
      this.bookedQuot.quotRouteList[i+1].inDt = moment(event, 'MM/DD/YYYY h:mm a').format('YYYYMMDDHHmm');
    }
    
    if(this.bookedQuot.quotRouteList[i].outDt != null) {
      if(type == 'sea') {
        this.tTimeCheckSea(this.bookedQuot.quotRouteList[i+1].inDt, this.bookedQuot.quotRouteList[i].outDt, i);
      } else {
        this.tTimeCheckAir(this.bookedQuot.quotRouteList[i+1].inDt, this.bookedQuot.quotRouteList[i].outDt, i);
      }
      
    }

    // this.postRoute(i+1);
  }

  tTimeCheckAir(inDt, outDt, i) {
    var duration = moment.duration(moment(inDt, 'YYYYMMDDHHmm').diff(moment(outDt, 'YYYYMMDDHHmm')));
    var tTime = duration.asMinutes();
    this.bookedQuot.quotRouteList[i].tTime = moment.duration(tTime, "minutes").format("D[일] H[시간] m[분]");
  }

  tTimeCheckSea(inDt, outDt, i) {
    var duration = moment.duration(moment(inDt, 'YYYYMMDD').diff(moment(outDt, 'YYYYMMDD')));
    var tTime = duration.asMinutes();
    this.bookedQuot.quotRouteList[i].tTime = moment.duration(tTime, "minutes").format("D[일]");
  }

  // postRoute(i) {

  //   let line:any;
  //   if(this.cnsltnReq.transTp == 1) {
  //     line = _.find(this.lineList, {name: this.bookedQuot.quotRouteList[i].linerNm });
  //   }else{
  //     line = _.find(this.lineList, {lineNm: this.bookedQuot.quotRouteList[i].linerNm });
  //   }
    
    
    
  //   if(line && line.lineCd){
  //     this.bookedQuot.quotRouteList[i].linerCd = line.lineCd;
  //   }else{
  //     this.bookedQuot.quotRouteList[i].linerCd = "";
  //   }

  //   var route: RouteEditModel = new RouteEditModel();
  //   route = _.omit(this.bookedQuot.quotRouteList[i], ['transType', 'vslVoy', 'tTime', 'typeNm']);
  //   this.quotationService.postQuotRoute(this.cnsltnReq.reqNo, route).subscribe(
  //     resp => {
  //       if(resp.result) {
  //         console.log('루트가 저장되었습니다');
  //       } else {
  //         console.log('루트가 저장되지 않았습니다.');
  //       }
  //     }
  //   );
  // }

  timeCheck(checkTime) {
    let timevalue = moment(checkTime, 'HHmm');
    let mid = moment('1200', 'HHmm');

    if(timevalue.isSameOrAfter(mid)) {
      return 'PM';
    } else {
      return 'AM';
    }
  }

  addFileTypeChange(event) {
    if(event=='ETC') {
      this.fileTypeETC = true;
    }    
    this.fileType = event;
  }

  addFileList() {
    if(this.cnsltnReq.stusCd < 3){
      Util.alertWarn('부킹 승인 후 마감서류 요청이 가능합니다.');
      return ;
    }

    let fileType = null;
    if(!_.isEmpty(this.fileType)) {
      if(this.fileType == 'ETC') {
        fileType = this.fileTypeETCName;

        if(fileType == null || fileType == undefined || fileType.length <= 0){
          Util.alertWarn('기타 서류명을 등록해주세요.');
          return;
        }
      } else {
        fileType = this.fileType;
      }

      this.fileList.push({docNm: fileType, fileNm: null});
      this.quotationService.postTempFile(this.cnsltnReq.reqNo, [{docNm: fileType, fileNm: null}]).subscribe(
        resp => {
          if(resp.result) {
            this.editFileList(resp.data);
          };
        }
      );
      
    } else {
      this.alertService.error('요청할 서류의 타입을 선택하세요.');
    }
  }
  
  reqDocUploadFile(file, i) {
    let docNm = file.docNm;
    let body = { docId : file.docId };    
    
    // this.quotationService.deleteFile(body).subscribe(
    //   resp => {
    //     if(resp.result) {            
    //       this.quotationService.postFiles(this.uploader, this.cnsltnReq.reqNo, docNm);
    //     };
    //   }
    // );  

    this.quotationService.reqDocUploadFile(this.uploader, this.cnsltnReq.reqNo, docNm, file.docId);
    
    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
      var responsePath = JSON.parse(response);
      this.editFileList(responsePath.data);
    };
  }

  editFileList(resp) {
    this.docLst = resp;
    this.initFileList();
  }

  initFileList() {
    this.fileList = [];
    this.filledFileCount = [];
    
    if(this.docLst.length > 0) {
      for(let i = 0; i<this.docLst.length; i++) {
        if(this.docLst[i].docNm != 'cargoPic' ) {
          this.fileList.push(this.docLst[i]);
        }
        if(this.docLst[i].fileNm != null && this.docLst[i].fileNm != '' && this.docLst[i].docNm != 'cargoPic') {
          this.filledFileCount.push(this.docLst[i]);          
        } 
      }  
    }
  }

  cancelReqFile(file, i) {
    this.fileList.splice(i, 1);
    this.docLst.splice(i, 1);
    if(file.fileNm != null && file.fileNm != '') this.filledFileCount.splice(0, 1);
    this.quotationService.deleteFile(file.docId, this.cnsltnReq.reqNo, 'CANCEL').subscribe(
      resp =>{
        if(resp.result){
          this.editFileList(resp.data);
        }
      }
    );
  }

  onEmptyCfsSelect(event) {
    this.selectedEmptyCfs = event;
  }

  onInCfsSelect(event) {
    this.selectedInCfs = event;
  }
  
  dateChange(event, closingTp) {
    let dateTime = moment(event).format('YYYYMMDD');
    if(closingTp == 'doc') {
      this.bookingSheet.docCloseDt = dateTime;
    } else if(closingTp == 'vgm') {
      this.bookingSheet.vgmCloseDt = dateTime;
    } else {
      this.bookingSheet.cargoCloseDt = dateTime;
    }
  }

  amPmChange(event, closingTp) {
    if(event == 'PM') {
      if(closingTp == 'doc') {
        this.docTimeList = this.timeListPm;
      } else if(closingTp == 'vgm') {
        this.vgmTimeList = this.timeListPm;
      } else {
        this.carTimeList = this.timeListPm;
      }
    } else {
      if(closingTp == 'doc') {
        this.docTimeList = this.timeListAm;
      } else if(closingTp == 'vgm') {
        this.vgmTimeList = this.timeListAm;
      } else {
        this.carTimeList = this.timeListAm;
      }
    }
  }

  timeChange(event, closingTp) {
    let time = moment(event, 'HH:mm').format('HHmm');
    if(closingTp == 'doc') {
      this.bookingSheet.docCloseTm = time;
    } else if(closingTp == 'vgm') {
      this.bookingSheet.vgmCloseTm = time;
    } else {
      this.bookingSheet.cargoCloseTm = time;
    }
  }

  postBookingSheet() {
    this.isBooking = true;
    this.quotationService.postBookingApproval(this.cnsltnReq.reqNo).subscribe(
      resp => {
        if(resp.result) {
          this.alertService.success('부킹이 승인되었습니다.');
          this.fileListEe.emit();          
        } else {
          this.alertService.error('오류가 발생했습니다. 다시한번 시도 해 주세요.');  
        }
        this.isBooking = false;
      },
      error => {
        this.isBooking = false;
        this.alertService.error('오류가 발생했습니다. 다시한번 시도 해 주세요.');        
      }
    );

  }

  saveBookingSheet() {
    this.isSaving = true;
    
    if(this.cnsltnReq.imexTp == 0) {
      this.bookingSheet.reqNo = this.cnsltnReq.reqNo;
      if(this.selectedEmptyCfs != null) this.bookingSheet.emptyCfs = this.selectedEmptyCfs;
      if(this.selectedInCfs != null) this.bookingSheet.inCfs = this.selectedInCfs;
      this.quotationService.saveBookingSheet(this.bookingSheet.reqNo, this.bookingSheet, this.bookedQuot.quotRouteList).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('부킹시트가 저장되었습니다.');          
          } else {
            this.alertService.error('오류가 발생했습니다. 다시한번 시도 해 주세요.');  
          }
          this.isSaving = false;
          this.fileListEe.emit();
        },
        error => {
          this.isSaving = false;
          this.alertService.error('오류가 발생했습니다. 다시한번 시도 해 주세요.');        
        }
      );
    } else {
      this.shippingAdvice.reqNo = this.cnsltnReq.reqNo;
      if(this.selectedInCfs != null)  this.shippingAdvice.destCfs = this.selectedInCfs; 
      this.quotationService.saveShippingAdvice(this.shippingAdvice.reqNo, this.shippingAdvice, this.bookedQuot.quotRouteList).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('Shipping Advice가 저장되었습니다.');          
          } else {
            this.alertService.error('오류가 발생했습니다. 다시한번 시도 해 주세요.');  
          }
          this.isSaving = false;
          this.fileListEe.emit();
        },
        error => {
          this.isSaving = false;
          this.alertService.error('오류가 발생했습니다. 다시한번 시도 해 주세요.');        
        }
      );
    }
    
  }

  
  rejectBooking() {
    this.showRejectModal = true;
    this.rejectQuotNo = this.cnsltnReq.quotNo;
    this.cancelCmt = new NewComment();
  }

  completeArrive(){
    this.isBooking = true;
    let that = this;
    $.sweetModal.confirm("도착 완료로 변경하시겠습니까?", function() {
      that.quotationService.completeArrive(that.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success('도착 완료 상태로 변경되었습니다.');
            that.isBooking = false;                
            that.fileListEe.emit();      
          } else {
            that.alertService.error(resp.errorMsg);
            that.isBooking = false;          
          }          
        }
      );
    });
  }

  completeTrans(){
    this.isBooking = true;
    let that = this;
    $.sweetModal.confirm("운송 완료로 변경하시겠습니까?", function() {
      that.quotationService.completeTrans(that.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success('운송 완료 상태로 변경되었습니다.');     
            that.isBooking = false;     
            that.fileListEe.emit();                 
          } else {
            that.alertService.error(resp.errorMsg);
            that.isBooking = false;               
          }          
        }
      );
    });
  }

  cancelArrive(){
    this.isBooking = true;
    let that = this;
    $.sweetModal.confirm("도착 취소로 변경하시겠습니까?", function() {
      that.quotationService.cancelArrive(that.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success('도착 취소 상태로 변경되었습니다.');
            that.isBooking = false;
            that.fileListEe.emit();            
          } else {
            that.alertService.error(resp.errorMsg);
            that.isBooking = false;
          }          
        }
      );
    });
  }

  cancelTrans(){
    this.isBooking = true;
    let that = this;
    $.sweetModal.confirm("운송 취소로 변경하시겠습니까?", function() {
      that.quotationService.cancelTrans(that.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success('운송 취소 상태로 변경되었습니다.');
            that.fileListEe.emit();
            that.isBooking = false;            
          } else {
            that.alertService.error(resp.errorMsg);
            that.isBooking = false;            
          }          
        }
      );
    });
  }

  downFile(file, i) {
    this.apiService.getToken(res => {
      const access_token = sessionStorage.getItem('_vcd');
      if (access_token) {
        let url = BASE_URL + '/consult/document?reqno=' + this.cnsltnReq.reqNo + '&docId=' + file.docId + '&token=' + access_token;
        var link = document.createElement("a");
        link.download = url;
        link.href = url;
        link.click();
      }
    });
  }

  lineInput(event, i){
    this.routeClickIndex = i; 
    let val = "";
    if(event && event.target) val = event.target.value;
    else val = event;

    // if (!val) {
    //   if (this.selectedAirLine) this.selectedAirLine = null;
    //   this.isAirLineListOpen = false;
    //   this._cnsltnQuotRoute.linerNm = '';
    //   this._cnsltnQuotRoute.linerCd = '';
    //   return;
    // }
    if(!val && val.length < 2) {
      this.isLineOpen = false;

    } else {
      this.isLineOpen = true;
      let keyword = _.trim(_.upperCase(val));

      this.filterLineList = _.map(_.filter(this.lineList,
                (line:any) => {
                  if(this.cnsltnReq.transTp == 0){
                    if (keyword.length <= 0) return true;
                    else if (_.upperCase(line.lineNm).indexOf(keyword) >= 0) return true;
                    else if (_.upperCase(line.lineCd).indexOf(keyword) >= 0) return true;
                    else return false;
                  }else{
                    if (keyword.length <= 0) return true;
                    else if (_.upperCase(line.name).indexOf(keyword) >= 0) return true;
                    else if (_.upperCase(line.lineCd).indexOf(keyword) >= 0) return true;
                    else if (_.upperCase(line.iataCd).indexOf(keyword) >= 0) return true;
                    else return false;
                  }
                }));

      this.filterLineList = _.sortBy(this.filterLineList,
              (line:any) => {
                let lineNm;
                let lineCd;
                if(this.cnsltnReq.transTp == 0){
                  lineNm = line.lineNm;
                  lineCd = line.lineCd;
                }else{
                  lineNm = line.name;
                  lineCd = line.lineCd;
                }
                let nmIndex = _.upperCase(lineNm).indexOf(keyword);
                let cdIndex = _.upperCase(lineCd).indexOf(keyword);
                if (nmIndex < 0) nmIndex = 999;
                if (cdIndex < 0) cdIndex = 999;
                return _.min([nmIndex, cdIndex])
              });
      }
  }

  lineBlur(i){
    this.focusedLineIndex = 0;
    this.isLineOpen = false;
  }

  lineKeyDown(event, i) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

    let suggestListItem = this.lineListElRef.nativeElement.querySelectorAll('li');
		switch (event.keyCode) {
			case 13: // enter
				this.lineSelect(this.filterLineList[this.focusedLineIndex], i);
			  break;
			case 27: // escape
			  break;
      case 38: // up
        this.focusedLineIndex--;
        if (this.focusedLineIndex < 0) this.focusedLineIndex = 0;
        suggestListItem[this.focusedLineIndex].scrollIntoViewIfNeeded(true);
        break;
      case 40: // down
      this.focusedLineIndex++;
        if (this.focusedLineIndex > suggestListItem.length - 1) this.focusedLineIndex = suggestListItem.length - 1;
        suggestListItem[this.focusedLineIndex].scrollIntoViewIfNeeded(false);
        break;
    default: console.log("event.keyCode:", event.keyCode);return;
		}
  }
  
  lineSelect(line:any, i){
    for (let idx = i ; idx >= 0 ; idx--) {
      if (this.bookedQuot.quotRouteList[idx].typeCdNm == 'DOOR' || this.bookedQuot.quotRouteList[idx].typeCdNm == 'RAIL') break;
      this.bookedQuot.quotRouteList[idx].linerCd = line.lineCd;

      if(this.cnsltnReq.transTp == 0){
        this.bookedQuot.quotRouteList[idx].linerNm = line.lineNm;
      }else{
        this.bookedQuot.quotRouteList[idx].linerNm = line.name;
      }
    }

    for (let idx = i ; idx < this.bookedQuot.quotRouteList.length ; idx++) {
      if (this.bookedQuot.quotRouteList[idx].typeCdNm == 'DOOR' || this.bookedQuot.quotRouteList[idx].typeCdNm == 'RAIL') break;
      this.bookedQuot.quotRouteList[idx].linerCd = line.lineCd;

      if(this.cnsltnReq.transTp == 0){
        this.bookedQuot.quotRouteList[idx].linerNm = line.lineNm;
      }else{
        this.bookedQuot.quotRouteList[idx].linerNm = line.name;
      }
    }

		this.filterLineList = null;
    this.focusedLineIndex = 0;
  }

  sendLinerEmail(){
    let that = this;
    $.sweetModal.confirm("선사 등록 이메일을 발송하시겠습니까?", function() {
      that.quotationService.postSendEmailLiner(that.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success('선사 등록 이메일이 발송되었습니다.');
            that.fileListEe.emit();            
          } else {
            that.alertService.error(resp.errorMsg);
          }          
        }
      );
    });
  }

  confirmRejectBooking() {
    if(_.isEmpty(this.cancelCmt.cmnt)) {
      Util.alertWarn('부킹거절사유를 선택해주세요.');
      return;
    }

    this.cancelCmt.quotNo = this.rejectQuotNo;
    this.cancelCmt.reqNo = this.cnsltnReq.reqNo;
    this.cancelCmt.corpId = 150;
    this.cancelCmt.cmntType = 2;
    this.quotationService.rejectBooking(this.cnsltnReq.reqNo, this.cancelCmt).subscribe(
      resp => {
        if(resp.result) {
          Util.alertSuccess('부킹이 거절되었습니다.');
          this.fileListEe.emit();
        } else {
          Util.alertWarn(resp.errorMsg);
        }

        this.hideRejectBookingModal();
      },
      error => {
        Util.alertWarn('오류가 발생했습니다. 다시한번 시도 해 주세요.');        
      }
    );
  }

  hideRejectBookingModal() {
    this.showRejectModal = false;
    this.rejectQuotNo = null;
  }

  selectRejectReason(event) {
    if(event.target.checked) {
      let val = event.target.value;
      if(val == 3) {
        this.rejectisNotEtc = false;
      } else {
        this.rejectisNotEtc = true;
      }

      if(val == 0) {
        this.cancelCmt.cmnt = '라이센스 대행불가';
      }else if(val == 1) {
        this.cancelCmt.cmnt = '스페이스 부족';
      } else if(val == 2) {
        this.cancelCmt.cmnt = '스케줄 불가';
      } else {
        this.cancelCmt.cmnt = null;
      }
    }
  }

  deleteFile(file, i) {
    let docNm = file.docNm;
    this.fileList.splice(i, 1);
    this.filledFileCount.splice(i, 1);
    this.fileList.push({docId : file.docId, docNm: docNm, fileNm: null});

    this.quotationService.deleteFile(file.docId, this.cnsltnReq.reqNo).subscribe(
      resp => {
        if(resp.result) {
          this.quotationService.postTempFile(this.cnsltnReq.reqNo, [{docId : file.docId, docNm: docNm, fileNm: null}]).subscribe(
            resp => {
              if(resp.result) {
                this.editFileList(resp.data);
              };
            }
          );
        };
      });  
  }
  
}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/booking-sheet.ts